import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import { HashRouter, Routes, Route, useLocation } from 'react-router-dom';

// Global styles
import './index.css';

// Components and pages
import Navbar from './Navbar.jsx';
import Footer from './Footer.jsx';
import Home from './Home.jsx';
import AboutUs from './AboutUs.jsx';
import OurWork from './OurWork.jsx';
import Donate from './Donate.jsx';
import ContactUs from './ContactUs.jsx';
import RaiseFund from './RaiseFund.jsx';
import Newsroom from './Newsroom-2.jsx';
import NewsroomDonner from './Newsroom.jsx';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function App() {
  return (
    <HashRouter>
      <ScrollToTop />
      <Navbar />
      <main style={{ minHeight: '100vh' }}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/our-work" element={<OurWork />} />
          <Route path="/donate" element={<Donate />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/raise-fund" element={<RaiseFund />} />
          <Route path="/newsroom" element={<Newsroom />} />
          <Route path="/DonorsDen" element={<NewsroomDonner />} />
        </Routes>
      </main>
      <Footer />
    </HashRouter>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
